import { useTheme } from "@hooks";
import { IconProps } from "./types";

export const RadioEmpty2 = ({ size = 20, style, fill: fillProp }: IconProps) => {
  const { theme } = useTheme();

  const fill = fillProp ?? theme.radio.unfilled;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <rect width={size} height={size} rx="10" fill={fill} />
    </svg>
  );
};
